// src/components/common/ExploreButton.jsx

function ArrowRight({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  );
}

export default function ExploreButton({
  children,
  onClick,
  className = "",
  ariaLabel,
}) {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel ?? (typeof children === "string" ? children : "Explore")}
      className={`
        group relative inline-flex items-center overflow-hidden
        rounded-full border border-white/20
        bg-white/10 text-white backdrop-blur-[2px]
        transition-colors duration-300
        hover:bg-white/40 hover:shadow-[0_0_20px_4px_rgba(255,255,255,0.25)]
        px-4 py-2 mobile:py-2 ${className}
      `}
    >
      <span
        className="
          flex items-center gap-1 whitespace-nowrap
          transform-gpu will-change-transform
          transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]
          group-hover:opacity-0 group-hover:translate-x-6
        "
      >
        <span>{children}</span>
        <ArrowRight />
      </span>

      <span
        className="
          pointer-events-none absolute inset-0
          flex items-center justify-center gap-1 whitespace-nowrap
          transform-gpu will-change-transform
          opacity-0 -translate-x-6
          transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]
          group-hover:opacity-100 group-hover:translate-x-0
        "
      >
        <ArrowRight />
        <span>{children}</span>
      </span>
    </button>
  );
}
